export function secondsToReadableFormat(totalSeconds: number): string {
    const absSeconds = Math.abs(totalSeconds);

    const secondsInADay = 86400;
    const secondsInAnHour = 3600;
    const secondsInAMinute = 60;

    const days = Math.floor(absSeconds / secondsInADay);
    const hours = Math.floor((absSeconds % secondsInADay) / secondsInAnHour);
    const minutes = Math.floor((absSeconds % secondsInAnHour) / secondsInAMinute);
    const seconds = absSeconds % secondsInAMinute;

    const daysPart = days > 0 ? `${days}d` : '';
    const hoursPart = hours > 0 ? `${hours}h` : '';
    const minutesPart = minutes > 0 ? `${Math.ceil(minutes)}m` : '';
    const secondsPart = seconds > 0 ? `${Math.ceil(seconds)}s` : '';
    const parts = [daysPart, hoursPart, minutesPart, secondsPart].filter((part) => part !== '');
    return parts.join(' ') || '0s';
}

export function minutesToReadableFormat(totalMinutes: number): string {
    const absMinutes = Math.abs(totalMinutes);

    const days = Math.floor(absMinutes / 1440);
    const hours = Math.floor((absMinutes % 1440) / 60);
    const minutes = absMinutes % 60;

    const daysPart = days > 0 ? `${days}d` : '';
    const hoursPart = hours > 0 ? `${hours}h` : '';
    const minutesPart = minutes > 0 ? `${Math.ceil(minutes)}m` : '';
    const parts = [daysPart, hoursPart, minutesPart].filter((part) => part !== '');
    return parts.join(' ') || '0m';
}
